import { Box, Button, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { FiArrowRight, FiClock } from "react-icons/fi";
import type { IconType } from "react-icons";
import { Link as RouterLink } from "react-router-dom";

type Action =
  | { label: string; to: string }
  | { label: string; onClick: () => void; isLoading?: boolean };

interface Props {
  icon?: IconType;
  title: string;
  description?: string;
  action?: Action;
}

export const NotReadyCard = ({ icon = FiClock, title, description, action }: Props) => (
  <Flex
    bg="smBackground"
    border="1px solid"
    borderColor="smBorder"
    rounded="xl"
    px={{ base: "4", md: "6" }}
    py="5"
    gap="4"
    align={{ base: "stretch", md: "center" }}
    justify="space-between"
    direction={{ base: "column", md: "row" }}
  >
    <Flex align="flex-start" gap="3">
      <Icon as={icon} aria-hidden boxSize="5" color="smMuted" mt="0.5" flexShrink={0} />
      <Stack spacing="1">
        <Text fontWeight="semibold" color="smText">
          {title}
        </Text>
        {description && (
          <Text fontSize="sm" color="smMuted">
            {description}
          </Text>
        )}
      </Stack>
    </Flex>
    {action && (
      <Box flexShrink={0} w={{ base: "100%", md: "auto" }}>
        <Button
          {...("to" in action
            ? { as: RouterLink, to: action.to, rightIcon: <Icon as={FiArrowRight} /> }
            : { onClick: action.onClick, isLoading: action.isLoading })}
          colorScheme="teal"
          w={{ base: "100%", md: "auto" }}
          whiteSpace={{ base: "normal", md: "nowrap" }}
          h={{ base: "auto", md: "10" }}
          py={{ base: "2.5", md: "0" }}
        >
          {action.label}
        </Button>
      </Box>
    )}
  </Flex>
);
